module.exports = __webpack_public_path__ + "static/media/beisboldominicano.d6535af2.jpg";